<template>
  <div class="modal-container">
    <div class="blur-backdrop" @click="close" />
    <div class="modal delete-pack-modal">
      <div class="title danger">
        Delete Prompt Pack
      </div>
      <div class="explanatory-text delete-pack-modal">
        Are you sure you want to delete the "{{ this.promptPack.promptPackName }}" prompt pack?
      </div>
      <div class="explanatory-text delete-pack-modal">
        This is permanent and cannot be undone! Only the pack will be deleted. You can still find your prompts in your prompt library.
      </div>
      <SpinnerButton
        class="button danger"
        :isProcessing="isDeletingPromptPack"
        @click="deletePromptPack"
      >
        Delete Prompt Pack
      </SpinnerButton>
      <SpinnerButton
        class="button"
        :isProcessing="isDeletingPromptPack"
        :showSpinner="false"
        @click="close"
      >
        Go Back
      </SpinnerButton>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import SpinnerButton from '@/components/utilComponents/SpinnerButton.vue';

export default Vue.extend({
  name: 'DeletePackModal',
  components: {
    SpinnerButton
  },
  props: {
    promptPack: Object
  },
  data: () => ({
    isDeletingPromptPack: false,
  }),
  computed: {
    auth0UserId: function () {
      return this.$auth.user.sub.replace(/\|/g, '_');
    },
    idToken: function () {
      return this.$auth.idToken;
    }
  },
  methods: {
    async deletePromptPack() {
      if (!this.promptPack.promptPackId || this.isDeletingPromptPack) {
        return;
      }
      this.isDeletingPromptPack = true;
      await this.axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/deletepromptpack`, {
        auth0UserId: this.auth0UserId,
        promptPackId: this.promptPack.promptPackId
      }, {
        headers: {
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${this.idToken}`
        }
      });
      this.isDeletingPromptPack = false;
      this.$emit('prompt-pack-deleted');
      this.close();
    },
    close() {
      if (this.isDeletingPromptPack) {
        return;
      }
      this.$emit('close');
    }
  }
})
</script>

<style scoped lang="scss">
@import '@/styles/modal-styles.scss';
</style>
